import "../../assets/css/carousel.scss";
import "../../assets/css/grid.scss";
import "../../assets/css/style.scss";
import Header from "../layout/Header";
// import Faq from "../common/Faq";
import Footer from "../layout/Footer";
// import Pricing from "../common/Pricing";
import BannerEvents from "../common/BannerEvents";
import EventListStatic from "../common/EventListStatic";

function EventsPage() {
  return (
    <div className="App">
      <Header />
      <BannerEvents />
      <EventListStatic />
      {/* <Faq /> */}
      {/* <Pricing /> */}
      <Footer />
    </div>
  );
}

export default EventsPage;
